import { type ReactNode, createContext, useContext, useState } from 'react'

type EnPIStatus = {
  /**
   * The error status here is only to show a toast when an error ocurrs. This gets reset to 'idle' right afterwards.
   * If you want the permanent error state of enpi you should use `enpi.lastUpdateFailed`.
   */
  status: 'idle' | 'loading' | 'success' | 'error'
  message?: string
}

interface EnPIContextType {
  enpiStatusDict: Record<number, EnPIStatus>
  setEnpiStatus: (id: number, status: EnPIStatus) => void
}

const EnPIContext = createContext<EnPIContextType | undefined>(undefined)

interface EnPIProviderProps {
  children: ReactNode
}

export const EnPIProvider = ({ children }: EnPIProviderProps) => {
  const [enpiStatusDict, setEnpiStatusDict] = useState<Record<number, EnPIStatus>>({})

  const setEnpiStatus = (id: number, status: EnPIStatus) => {
    setEnpiStatusDict(prev => ({ ...prev, [id]: status }))
  }

  return <EnPIContext.Provider value={{ enpiStatusDict, setEnpiStatus }}>{children}</EnPIContext.Provider>
}

export const useEnPIContext = () => {
  const context = useContext(EnPIContext)
  if (context === undefined) {
    throw new Error('useEnPIContext must be used within a EnPIProvider')
  }
  return context
}
